import React, { useEffect, useRef, useState } from 'react'
import '../Style/Blogs_Page.css'
import BlogImage from '../Blogs_Icons/blog_resized_900_450_49_1639295414_types_ceiling_lamps (1).jpg'
import { Link } from 'react-router-dom'
import CalenderIcon from '../Logos/calendar.svg'
import PenIcon from '../Logos/pen-tool.svg'
import TagIcon from '../Logos/tag.svg'
import ArrowRight from '../Logos/arrow-right.svg'
import axios from 'axios'
import SearchIcon from '../Logos/search.svg'
import Loading_Screen from '../Components/Loading_Screen'

function Blogs() {
    const [Datas, SetDatas] = useState([])
    const [Tags, setTags] = useState()

    const Search_Text = useRef()
    const Search_Input = useRef()

    const [Loading, SetLoading] = useState(true)


    const Filter_By_Tag_Ref = useRef()
    const Tags_List_Container = useRef()
    const [Filter_By_Tag_Tags_List_Opened, ToggleFilter_By_Tag_Tags_List] = useState(false)


    useEffect(() => {
        axios.post("http://127.0.0.1:3001/blogs")
            .then(data => {
                SetDatas(data.data)
            })
            .catch(err => { console.log(err) })

        Search_Input.current.addEventListener("focus", () => {
            Search_Text.current.style.transform = "translateY(-20px)"
            Search_Text.current.style.fontSize = "12px"
            Search_Text.current.style.color = "black"

        });
        Search_Input.current.addEventListener("focusout", () => {
            if (!Search_Input.current.value.length > 0) {
                Search_Text.current.style.transform = "translateY(0px)"
                Search_Text.current.style.fontSize = "15px"
                Search_Text.current.style.color = "#a7a7a7"
            }
        });
    }, [])

    const Toogle_Filter_By_Tag = () => {
        if (!Filter_By_Tag_Tags_List_Opened) {
            ToggleFilter_By_Tag_Tags_List(true)
            Filter_By_Tag_Ref.current.style.transform = "rotate(90deg)"
            Tags_List_Container.current.style.display = "flex"
        } else {
            ToggleFilter_By_Tag_Tags_List(false)
            Filter_By_Tag_Ref.current.style.transform = "rotate(0deg)"
            Tags_List_Container.current.style.display = "none"
        }
    }
    return (
        <>
            <main onLoad={() => {SetLoading(false)}}>
                {Loading? <Loading_Screen /> : null}
                <div className='search-container'>
                    <div className='wrapper'></div>
                    <div className='filter-by-date'>
                        <input type='date' name='date_input'/>
                    </div>
                    <div className='wrapper'></div>
                    <div className='filter-by-tag'>
                        <div className='current-tag' onClick={() => { Toogle_Filter_By_Tag() }}>
                            <img src={ArrowRight} className='arrow-right' ref={Filter_By_Tag_Ref} />
                            <div className='text'>لامپ</div>
                        </div>
                        <div className='tags-list-container' ref={Tags_List_Container}>
                            <div className='tag-row'>
                                <input type='checkbox' name='' />
                                <div className='checkbox-tag-name'>لامپ</div>
                            </div>
                        </div>
                    </div>
                    <div className='wrapper'></div>
                    <div className='search-by-name-container'>
                        <div className='text' ref={Search_Text}>جست جو بلاگ</div>
                        <img src={SearchIcon} className='search-icon' />
                        <input type='text' name='search_blog_by_title' ref={Search_Input} />
                    </div>
                </div>
                <div className='wrapper'></div>
                <div className='blogs-list-container'>
                    {Datas.map((Blogs, key) => {
                        const TagsArray = JSON.parse(Blogs.tags)
                        return <div className='blog-card'>
                            <div className='blog-title'>{Blogs.title}</div>
                            <div className='blog-details'>
                                <div className='blog-tags'>
                                    <div className='tags'>تگ ها: {TagsArray.map((items, key) => { return " | " + items })}</div>
                                    <img src={TagIcon} className='details-icon' alt='calender-icon' />
                                </div>
                                <div className='blog-writer'>
                                    <div className='writer'>نویسنده: {Blogs.writer}</div>
                                    <img src={PenIcon} className='details-icon' alt='calender-icon' />
                                </div>
                                <div className='blog-date'>
                                    <div className='date'>تاریخ افزودن: {Blogs.date}</div>
                                    <img src={CalenderIcon} className='details-icon' alt='calender-icon' />
                                </div>
                            </div>
                            <Link to={Blogs.link} className='blog-image-container'>
                                <img src={require(`../Blogs_Icons/${Blogs.thumbnail}`)} alt='blog-image-alt' className='blog-image' />
                            </Link>
                            <div className='blog-description'>{Blogs.main_description.substring(0, 338)}</div>
                            <Link to={Blogs.link} className='read-more-blog'>ادامه مطلب</Link>
                        </div>
                    })}
                </div>
            </main>
        </>
    )
}

{/* <div className='blog-card'>
<div className='blog-title'>تایتل</div>
<div className='blog-details'>
    <div className='blog-tags'>
        <div className='tags'>تگ ها:</div>
        <img src={TagIcon} className='details-icon' alt='calender-icon' />
    </div>
    <div className='blog-writer'>
        <div className='writer'>نویسنده: علیرضا شیرمحمدی</div>
        <img src={PenIcon} className='details-icon' alt='calender-icon' />
    </div>
    <div className='blog-date'>
        <div className='date'>1402/4/29</div>
        <img src={CalenderIcon} className='details-icon' alt='calender-icon' />
    </div>
</div>
<Link to={"/"} className='blog-image-container'>
    <img src={BlogImage} alt='blog-image-alt' className='blog-image' />
</Link>
<div className='blog-description'>شاید برای خیلی‌ها این سوال پیش آمده باشد که کدام موقع خرید لامپ ال ای دی ( لامپ LED ) کدام رنگ را برای لامپ‌ها و پروژکتورهای خود انتخاب کنیم، نور سفید یا زرد؟ مهتابی یا آفتابی؟ هر کدام از لامپ ها در کجا باید استفاده شود، برای پاسخ این سوالات با این مطلب از وبلاگ الکتروتچ همراه باشید.</div>
<Link to={"/"} className='read-more-blog'>ادامه مطلب</Link>
</div> */}
export default Blogs